import { Injectable } from '@angular/core';

@Injectable()
export class GlobalConfig {
  gcmToken: any = '';
  currentUser: any = {};
  apiRootUrl: any = window['apiUrl'];
  confirmService: { confirmMessage: any };
  modelServiceData: any;
  bucketService: any;
  clientId: any = window['clientId']; '96da4c26-83c2-405c-a253-4651b437bb51';
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/entities/global-config.ts